module.exports = __webpack_public_path__ + "static/img/add-image-plus.3a6e8ad4.svg";